export default {
      id: "dashboards-usage",
      viewBox: "0 0 27 27",
      url: __webpack_public_path__ + "img/icons.8ad0c046.svg#dashboards",
      toString: function () {
        return this.url;
      }
    }